import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

export const CurrencySelectOption = (props: OptionProps<TOption>) => (
  <components.Option {...props}>
    <div className="flexbox justify-content--between align-items--center">
      <div>
        <div className="flexbox rounded">
          <Image imagePath={props.data?.meta as string}/>
          <Text className="px-8" type="secondary">{props.data?.label}</Text>
        </div>
      </div>
      <div className="flexbox">
        {props.isSelected && (
          <CloudFlareImage className="ml-4" path={CloudflareAsset.SelectedOption}/>
        )}
      </div>
    </div>
  </components.Option>
);
